import React, {useEffect, useRef, useState} from "react";
import {Form, Input, InputNumber, Tooltip} from "antd";

interface InputComponentProps {
  tooltip?: string | JSX.Element
  suffix?: string | JSX.Element
  label?: string
  placeholder?: string;
  bgColor?: string;
  type?: "number" | "email" | undefined;
  required?: boolean;
  warning?: string;
  initialFieldValue?: string | number | undefined;
  message?: string;
  name?: string;

  validation?(e: any): any

  onChange?(e: any): void
}

const InputComponent = ({
                          validation,
                          name,
                          tooltip,
                          suffix,
                          label,
                          initialFieldValue,
                          type,
                          onChange,
                          required,
                          message,
                          ...props
                        }: InputComponentProps) => {
  const [focus, setFocus] = useState<"focused-datepicker" | undefined>(!!initialFieldValue ? "focused-datepicker" : undefined);
  const [value, setValue] = useState<any>(initialFieldValue);
  const [validationMessage, setMessage] = useState<string | undefined>(message);
  const inputRef = useRef<any>(null);
  useEffect(() => {
    inputRef.current.defaultValue && inputRef.current?.defaultValue && setFocus("focused-datepicker");
    inputRef.current.defaultValue && setValue(inputRef.current?.defaultValue);
  }, [initialFieldValue, inputRef]);

  const checkConfirmation = (_rule: any, value: any) => {
    if (validation && validation(value) === false) {
      setMessage(message);
      return Promise.resolve()
    } else {
      setMessage(validation && validation(value));
      return Promise.reject(validation ? validation(value) : "")
    }

  };
  const rules = required && validation ? [
    {
      validator: checkConfirmation
    }
  ] : undefined;

  return (
    <div className={"select"}>
      <div className={`select-label ${focus}`} onClick={() => inputRef.current?.focus()}>{label}</div>
      {type === "number" ?
        (<Form.Item
          style={{width: "100%", display: "flex", justifyContent: "center"}}
          rules={[{required: required, message: message}]}
          name={name}>
          <InputNumber
            ref={inputRef}
            min={1}
            onFocus={() => setFocus("focused-datepicker")}
            onBlur={() => {
              !value && inputRef.current?.clearableInput && inputRef.current?.clearableInput.props.value === undefined && setFocus(undefined);
            }}
            formatter={(value: any) => {
              let price: string = value.replace(/\B(?=(\d{3})+(?!\d))/g, '');
              let splitted = price.split(".");
              let integer = splitted[0].replace(/\B(?=(\d{3})+(?!\d))/g, '');
              let decimal: string;
              decimal = splitted[1] && splitted[1].substr(0, 2);
              return !!decimal ? `${integer}.${decimal}` : integer;
            }}
            value={value}
            parser={(value: any) => value.replace(/\$\s?|(,*)/g, '')}
            onChange={(e) => {
              setValue(e);
              onChange && onChange(e)
            }}
            style={{
              width: "100%",
              borderRadius: "30px",
              padding: "8px 4px 8px 20px",
              backgroundColor: "transparent",
              border: "none"
            }}/>
        </Form.Item>) :
        type === "email" ?
          (<Form.Item
            style={{width: "100%", display: "flex", justifyContent: "center"}}
            rules={[{required: required, type: "email", message: "E-mail adresa nije ispravna"}]}
            name={name}>
            <InputNumber
              defaultValue={undefined}
              ref={inputRef}
              onFocus={() => setFocus("focused-datepicker")}
              onBlur={() => !value ? setFocus(undefined) : setFocus('focused-datepicker')}
              formatter={(value: any) => {
                let price: string = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                let splitted = price.split(".");
                let integer = splitted[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                let decimal: string;
                decimal = splitted[1] && splitted[1].substr(0, 2);
                return !!decimal ? `${integer}.${decimal}` : integer;
              }}
              parser={(value: any) => value.replace(/\$\s?|(,*)/g, '')}
              onChange={(e) => {
                setValue(e);
                onChange && onChange(e)
              }}
              style={{
                width: "100%",
                borderRadius: "30px",
                padding: "8px 4px 8px 20px",
                backgroundColor: "transparent",
                border: "none"
              }}/>
          </Form.Item>) :
          (<Form.Item
            style={{width: "100%", display: "flex", justifyContent: "center"}}
            rules={rules ? rules : [{required: required, message: message}]}
            name={name}>
            <Input
              //@ts-ignore
              ref={inputRef}
              style={{
                width: "100%",
                borderRadius: "30px",
                padding: "8px 4px 8px 20px",
                border: "none"
              }}
              onChange={(e) => {
                setValue(e);
                onChange && onChange(e)
              }}
              defaultValue={initialFieldValue}
              onFocus={() => setFocus("focused-datepicker")}
              onBlur={() => !value ? setFocus(undefined) : setFocus('focused-datepicker')}
              type={type}
            />
          </Form.Item>)
      }
      {suffix && suffix}
      {tooltip && <Tooltip title={tooltip}
                           placement="left"
                           color={"#fff"} overlayStyle={{color: "#000"}}>
          <span className={"inputTooltip"}>?</span>
      </Tooltip>}
    </div>
  )
};

export default InputComponent
